import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IQuotationScore } from '../../models/quotations.models';
export interface IDetailsCopilotScore {
  quote_name: string;
  score: IQuotationScore;
  overall_score: number;
}
@Component({
  selector: 'app-details-copilot-score',
  templateUrl: './details-copilot-score.component.html',
  styleUrls: ['./details-copilot-score.component.scss']
})
export class DetailsCopilotScoreComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDetailsCopilotScore,
    private dialogRef: MatDialogRef<DetailsCopilotScoreComponent>
  ) { 
    console.log(this.data);
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

}
